import { createLogger } from "@/lib/observability/logger";
import loadPlacesLibrary from "../common/load-places-library";

// getAddressPredictions gets address predictions from the Google Maps API
export default async function getAddressPredictions(
  query: string,
): Promise<google.maps.places.PlacePrediction[]> {
  const logger = createLogger("getAddressPredictions");
  if (!query) return [];

  try {
    const { AutocompleteSuggestion } = await loadPlacesLibrary();

    const autocompleteResponse =
      await AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: query,
        includedPrimaryTypes: ["street_address", "premise", "subpremise"],
      });

    return autocompleteResponse.suggestions
      .map((suggestion) => suggestion.placePrediction)
      .filter(
        (prediction): prediction is google.maps.places.PlacePrediction =>
          prediction !== null,
      );
  } catch (error) {
    logger.logError("getAddressPredictions", error as Error);
    throw new Error("Unable to search addresses. Please try again.");
  }
}
